export default __webpack_public_path__ + "static/media/PS_frontpage_web.741abcbd.jpg";